import { Avatar, Flex, Space, Tag, Typography } from "antd";
import EllipsisText from "components/EllipsisText";
import dayjs from "dayjs";

const WorkerAvatar = ({ worker, assigned_at, master_worker }) => (
  <Flex align="center" justify="space-between" wrap gap={20}>
    <Space>
      <Avatar
        style={{
          backgroundColor: worker.color,
        }}
      >
        {worker.initials}
      </Avatar>
      <Typography.Text delete={worker.is_deleted}>
        <EllipsisText text={worker.full_name} limit={30} />
      </Typography.Text>
      {master_worker && <Tag color="#3b1757">Kierownik</Tag>}
    </Space>
    {assigned_at && (
      <Typography.Text type="secondary">
        Data przypisania: <br />
        {assigned_at ? dayjs(assigned_at).format("DD-MM-YYYY HH:mm") : "-"}
      </Typography.Text>
    )}
  </Flex>
);

export default WorkerAvatar;
